import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { billedUponIsTriggerShaped } from './agreementOccurrence';
import { activeServiceQuantifier } from './AgreementPredicateChips.utils';
export const ADDABLE_FILTER_GROUPS = [
    {
        group: 'agreements',
        keys: [
            'status',
            'effectiveDate',
            'lastBilled',
            'paymentMethod',
            'amendmentStatus',
            'hasCredit',
            'automaticPriceIncrease'
        ]
    },
    {
        group: 'services',
        keys: [
            'serviceName',
            'serviceStatus',
            'billingTrigger',
            'occurrence',
            'automaticServices'
        ]
    }
];
export const ADDABLE_FILTER_KEYS = ADDABLE_FILTER_GROUPS.flatMap((g)=>g.keys);
const SET_KEYS = new Set([
    'status',
    'paymentMethod',
    'amendmentStatus',
    'hasCredit',
    'automaticPriceIncrease'
]);
const OBJECT_KEYS = new Set([
    'effectiveDate',
    'lastBilled'
]);
export const isAddableFilterPresent = (filter, key)=>{
    switch(key){
        case 'occurrence':
            {
                const billedUpon = serviceSubField(filter, 'billedUpon');
                return serviceSubField(filter, 'recurrence') != null || billedUpon != null && !billedUponIsTriggerShaped(billedUpon);
            }
        case 'billingTrigger':
            return serviceSubField(filter, 'billedUpon') != null;
        case 'automaticServices':
            return serviceSubField(filter, 'automaticState') != null;
        case 'serviceName':
            {
                var _filter_services;
                var _filter_services1;
                const quantifier = activeServiceQuantifier((_filter_services = filter.services) !== null && _filter_services !== void 0 ? _filter_services : {});
                const service = quantifier == null ? undefined : (_filter_services1 = filter.services) === null || _filter_services1 === void 0 ? void 0 : _filter_services1[quantifier];
                return service != null && (service.name != null || service.or != null);
            }
        case 'serviceStatus':
            return serviceSubField(filter, 'completionState') != null;
        default:
            return filter[key] != null;
    }
};
export const addEmptyFilter = (filter, key)=>{
    var _activeServiceQuantifier, _filter_services, _ref;
    var _filter_services1;
    if (SET_KEYS.has(key)) return _object_spread_props(_object_spread({}, filter), {
        [key]: {
            in: []
        }
    });
    if (OBJECT_KEYS.has(key)) return _object_spread_props(_object_spread({}, filter), {
        [key]: {}
    });
    if (key === 'occurrence') return withServiceSubField(filter, 'recurrence', {
        in: []
    });
    if (key === 'automaticServices') return withServiceSubField(filter, 'automaticState', {
        in: []
    });
    if (key === 'serviceStatus') return withServiceSubField(filter, 'completionState', {
        in: []
    });
    if (key === 'billingTrigger') return withServiceSubField(filter, 'billedUpon', {
        in: []
    });
    const quantifier = (_activeServiceQuantifier = activeServiceQuantifier((_filter_services = filter.services) !== null && _filter_services !== void 0 ? _filter_services : {})) !== null && _activeServiceQuantifier !== void 0 ? _activeServiceQuantifier : 'any';
    return withServicesAtEnd(filter, {
        [quantifier]: _object_spread_props(_object_spread({}, (_ref = (_filter_services1 = filter.services) === null || _filter_services1 === void 0 ? void 0 : _filter_services1[quantifier]) !== null && _ref !== void 0 ? _ref : {}), {
            or: []
        })
    });
};
const withServicesAtEnd = (filter, services)=>{
    const { services: _replaced } = filter, rest = _object_without_properties(filter, [
        "services"
    ]);
    return _object_spread_props(_object_spread({}, rest), {
        services
    });
};
const serviceSubField = (filter, field)=>{
    var _filter_services;
    var _filter_services_quantifier, _filter_services1;
    const quantifier = activeServiceQuantifier((_filter_services = filter.services) !== null && _filter_services !== void 0 ? _filter_services : {});
    if (quantifier == null) return undefined;
    return (_filter_services1 = filter.services) === null || _filter_services1 === void 0 ? void 0 : (_filter_services_quantifier = _filter_services1[quantifier]) === null || _filter_services_quantifier === void 0 ? void 0 : _filter_services_quantifier[field];
};
const withServiceSubField = (filter, field, value)=>{
    var _activeServiceQuantifier, _filter_services, _ref;
    var _filter_services1;
    const quantifier = (_activeServiceQuantifier = activeServiceQuantifier((_filter_services = filter.services) !== null && _filter_services !== void 0 ? _filter_services : {})) !== null && _activeServiceQuantifier !== void 0 ? _activeServiceQuantifier : 'any';
    return withServicesAtEnd(filter, {
        [quantifier]: _object_spread_props(_object_spread({}, (_ref = (_filter_services1 = filter.services) === null || _filter_services1 === void 0 ? void 0 : _filter_services1[quantifier]) !== null && _ref !== void 0 ? _ref : {}), {
            [field]: value
        })
    });
};
